import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../stateManagement/hooks/redux";
import { useDispatch } from "react-redux";
import { setRoadBedTypeIds, setPavementGroups, setRoadBedLayerFilterIsOpened } from "../../../../../stateManagement/reducers/objectTypes/RoadBedLayerSegmentsSlice";
import { Checkbox, FormControlLabel } from "@mui/material";
import { getItemWebStorage, setItemWebStorage } from "../../../../../features/webStorageSaver";
import { roadBedLayersApiSlice } from "../../../../../api/rtk/base/slices/objectTypes/roadBedLayersApiSlice";
import { showToastMessage } from "../../../../../stateManagement/reducers";

const closeIcon = require('../../../../../assets/images/fontAwesomeIcons/xmark-solid-dark.svg').default
const filtersIcon = require('../../../../../assets/images/icons/filters-icon.svg').default

// Объект конфигурации фильтра "Тип дорожной одежды"
export const roadBedFiltersOptions: any = {
    fundamental: {
        name: 'Капитальный',
        roadbedTypeId: 1,
        color: '#ffa500'
    },
    transitional: {
        name: 'Переходный',
        roadbedTypeId: 3,
        color: '#e15112'
    },
    lightweight: {
        name: 'Облегчённый',
        roadbedTypeId: 2,
        color: '#9820dd'
    },
    inferior: {
        name: 'Низший',
        roadbedTypeId: 4,
        color: '#14c7c5'
    },
}

const optionsRoadBedInitialState = {
    fundamental: false,
    transitional: false,
    lightweight: false,
    inferior: false
}

export default function RoadBedLayerSegmentsOverlay() {
    const dispatch = useDispatch()
    const [isSmallForRoadBedStateFilter, setIsSmallForRoadBedStateFilter] = useState(false);
    const [optionsRoadBedState, setRoadBedState] = useState(getItemWebStorage("roadBedMapFilters") ?? optionsRoadBedInitialState);
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const isOpenedRoadBedLayersFilter = useAppSelector(state => state.roadBedLayerSegments.roadBedLayersFilterIsOpened)

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallForRoadBedStateFilter(contentHeaderWidth < 767);
    }, [sideBarState])

    function onCheckRoadBedFilters(fieldName: string, event: any) {
        setItemWebStorage('roadBedMapFilters', { ...getItemWebStorage("roadBedMapFilters"), [fieldName]: event.target.checked })
        dispatch(setRoadBedTypeIds({ ...getItemWebStorage("roadBedMapFilters"), [fieldName]: event.target.checked }))
        setRoadBedState((prevState: any) => ({ ...prevState, [fieldName]: event.target.checked }));
    }

    const {
        data: pavementGroups,
        isFetching: fetchingPavementGroups,
        isError: isErrorPavementGroups
    } = roadBedLayersApiSlice.useFetchPavementGroupsDictQuery({})

    useEffect(() => {
        if (isErrorPavementGroups) {
            dispatch(showToastMessage({ messageText: 'Ошибка загрузки протяженности участков дорожных одежд', messageType: "error", windowType: "map" }))
        }
    },[isErrorPavementGroups])

    useEffect(() => {
        if (pavementGroups) {
            dispatch(setPavementGroups(pavementGroups?.value))
        }
    }, [pavementGroups])

    return (
        <>
            {((isSmallForRoadBedStateFilter && isOpenedRoadBedLayersFilter) || !isSmallForRoadBedStateFilter) &&
                <div className="map-overlay-road-bed map-overlay">
                    {isSmallForRoadBedStateFilter &&
                        <div className="close-filter-window-button" onClick={() => dispatch(setRoadBedLayerFilterIsOpened(!isOpenedRoadBedLayersFilter))}>
                            <span>Закрыть</span>
                            <img src={closeIcon} />
                        </div>
                    }
                    <div className="road-bed-filters-div">
                        <div className="road-bed-checkbox-div">
                            {Object.keys(roadBedFiltersOptions).map((key => {
                                return (
                                    <div>
                                        <FormControlLabel
                                            className="check-string"
                                            key={`${key}RoadBed`}
                                            checked={optionsRoadBedState[key]}
                                            name={`${key}`}
                                            onChange={(event: any) => onCheckRoadBedFilters(`${key}`, event)}
                                            color={roadBedFiltersOptions[key].color}
                                            control={<Checkbox className="ch-white" style={{ color: roadBedFiltersOptions[key].color }} />}
                                            label={roadBedFiltersOptions[key].name}
                                        />
                                    </div>
                                )
                            }))}
                        </div>
                        <div className="road-bed-length-div">
                            {Object.keys(roadBedFiltersOptions).map((pavementGroup: any) => {
                                let length = pavementGroups && pavementGroups.value.find((pavementGroupItem: any) => pavementGroupItem.RoadbedType === roadBedFiltersOptions[pavementGroup].name)?.Length;
                                return <span>{length ? `${length} км` : '—'}</span>
                            })}
                        </div>
                    </div>
                </div>
            }
            {(isSmallForRoadBedStateFilter && !isOpenedRoadBedLayersFilter) &&
                <div className="roadBedLayerFilterTurnButton" onClick={() => dispatch(setRoadBedLayerFilterIsOpened(!isOpenedRoadBedLayersFilter))}>
                    <img src={filtersIcon} />
                    <span>Фильтры</span>
                </div>
            }
        </>
    )
}
